import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JSEncrypt } from 'jsencrypt';

import { OTP, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';

import { termsInitiateOtp, termsValidateOtp, termsResendOtp, addAppleCare, captureData } from '../../api/api';

import { handleApiError } from '../../functions/handleApiError';

import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import ErrorModal from '../ErrorModal/ErrorModal';
import captureStructure from '../../captureStructure.json';

import './TermsOTP.scss';


interface Props {
    handleHeaderCancel: () => void;
}

const win: any = window;

function TermsOTP({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, msisdn, scData, graphQlResponse, currentPage: stepName, selectedAcPlan, productData, planName, isInstallmentApplied, isSubsidyApplied, customerInfo, newStack } = state;
    const { t } = useTranslation();
    const uniqueProductNameArr = graphQlResponse?.getProductOfferByID[0]?.specCharValueUse.filter((val: any) => (val.name === 'Unique Technical Name'))[0];
    const uniqueProductName = uniqueProductNameArr?.specCharacteristicValue[0]?.value ? uniqueProductNameArr?.specCharacteristicValue[0]?.value : "";
    const acId = selectedAcPlan?.acId;
    const acName = selectedAcPlan?.acName;
    const scId = scData?.id;
    const ocId = scData?.offerContainer[0]?.id;

    const [otpValue, setotpValue] = useState('');
    const [showOTPError, setShowOTPError] = useState(false);
    const [notCustomer, setNotCustomer] = useState(false);
    const [isGenericError, setIsGenericError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorCode, setErrorCode] = useState("");
    const [timer, setTimer] = useState(0);
    const [hashCode, setHashCode] = useState("");
    const [resendOption, setResendOption] = useState(true);
    const [isOTPDisabled, setIsOTPDisabled] = useState(false);
    const cemPublicKey = win['cem_public_key'];
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(cemPublicKey);
    const lang = rtl ? 'ar' : 'en';

    const responseData = productData.getProductOfferByID[0];
    const productNameFilterEn = responseData?.specCharValueUse.filter(
        (val: any) => val.name === "Commercial name English"
    )[0];
    const productNameFilterAr = responseData?.specCharValueUse.filter(
        (val: any) => val.name === "Commercial name Arabic"
    )[0];

    const productNameEn = productNameFilterEn
        ?.specCharacteristicValue[0]?.value
        ? productNameFilterEn?.specCharacteristicValue[0]?.value
        : "";
    const productNameAr = productNameFilterAr
        ?.specCharacteristicValue[0]?.value
        ? productNameFilterAr?.specCharacteristicValue[0]?.value
        : "";


    useEffect(() => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        InitiateOtpApi()
    }, [])
    useEffect(() => {
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer((prevTimer: any) => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
    }, [timer]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: "CAPTURE_OTP_VALUE", payload: { otpValue: otp } });
            termsValidateOtpAPI(otp)
        }
    }

    const handleNotCustomer = () => {
        setNotCustomer(false);
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'TwoYearCoverageLogin' } });
    }
    const handleGenericError = () => {
        setIsGenericError(false);
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'TwoYearCoverageLogin' } });
    }


    const selectingPlanName = (planName: string) => {
        switch (planName) {
            case 'AppleCare+ warranty one time':
                return 'APPLE_CARE_UPFRONT_PAYMENT';
            case 'AppleCare+ warranty recurring':
                return 'APPLE_CARE_SUBSCRIPTION';
            default:
                return planName;
        }
    }

    const InitiateOtpApi = () => {
        let value = msisdn.replace(/^0/, "966");
        const encryptedNum = value ? jsencrypt.encrypt(value) : "";
        const encryptedPrice = selectedAcPlan?.price ? jsencrypt.encrypt(selectedAcPlan?.price?.toString()) : "";
        const encryptedDeviceName = rtl ? jsencrypt.encrypt(productNameAr) : jsencrypt.encrypt(productNameEn);
        const journeyName = selectingPlanName(planName);
        termsInitiateOtp(encryptedNum, lang.toUpperCase(), '4', 'Y', journeyName, encryptedDeviceName, encryptedPrice)
            .then((res: any) => {
                if (res?.status === 200) {
                    setHashCode(res?.data?.data?.refId);
                    setTimer(120);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch(err => {
                setErrorCode(err?.response?.status);
                setIsGenericError(true);
                dispatch({ type: "LOADER", payload: { loading: false } });
            })
    }

    const termsValidateOtpAPI = (otp: any) => {

        termsValidateOtp(otp, hashCode)
            .then((res: any) => {
                if (res.status === 204) {
                    dispatch({ type: "LOADER", payload: { loading: true } });
                    applyAppleCare(acId, acName, scId, ocId);
                } else if (res.status === 260) {
                    // Handle otp error cases
                    switch (res?.data?.status?.sourceCode) {
                        case "MAPI-260-2":
                            setErrorMessage(t("error_Invalid_OTP"));
                            setShowOTPError(true);
                            break;
                        case "MAPI-260-3":
                            setErrorMessage(t("error_OTP_expired"));
                            setShowOTPError(true);
                            break;
                        case "MAPI-260-4":
                            setIsOTPDisabled(true);
                            setErrorMessage(t("error_Max_attempt_reached"));
                            setShowOTPError(true);
                            break;
                        default:
                            //Audit API
                            setErrorCode(res?.data?.status?.sourceCode);
                            setIsGenericError(true);
                            break;
                    }
                    setTimer(0);
                    setotpValue('');
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    //Audit API
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch((err: any) => {
                setErrorCode(err?.res?.status);
                setIsGenericError(true);
                dispatch({ type: "LOADER", payload: { loading: false } });
            })
    }


    const handleResend = () => {
        dispatch({ type: "LOADER", payload: { loading: true } })

        termsResendOtp(hashCode)
            .then((res: any) => {
                if (res.status === 204) {
                    setotpValue('');
                    setIsOTPDisabled(false);
                    setTimer(120);
                    setShowOTPError(false);
                    dispatch({ type: "LOADER", payload: { loading: false } })
                } else if (res?.status === 260 && res?.data?.status?.sourceCode === "MAPI-260-1") {
                    setTimer(0);
                    setotpValue('');
                    setResendOption(false);
                    setErrorMessage(t("error_exceed_maxmium_amount"));
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    //Audit API
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch((err: any) => {
                setErrorCode(err?.response?.status);
                setIsGenericError(true);
                dispatch({ type: "LOADER", payload: { loading: false } });
            })
    }

    const handleBackArrow = () => {
        dispatch({ type: "LOADER", payload: { loading: false } })
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
    }

    const applyAppleCare = (acId: string, acName: string, scId: string, ocId: string) => {
        addAppleCare(acId, acName, scId, ocId)
            .then((response: any) => {
                const config = Object.assign(response?.config, { serviceName: 'addAppleCare' });
                const res = { ...response, config }

                if (res?.status === 201 && res?.data) {
                    dispatch({ type: 'SC_RESPONSE', payload: { scData: res.data } })
                    dispatch({ type: 'APPLECARE_APPLIED', payload: { appleCareApplied: true } })
                    console.log("testingCode: ", selectedAcPlan?.acName?.includes("AppleCare+ warranty recurring") && (!isInstallmentApplied) ? "true" : "false");
                    if (isInstallmentApplied || isSubsidyApplied) {
                        dispatch({ type: "LOADER", payload: { loading: false } })
                        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
                    } else {
                        if (selectedAcPlan?.acName?.includes("AppleCare+ warranty recurring")) {
                            dispatch({ type: "LOADER", payload: { loading: true } })
                            captureDataApi(scData);
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } })
                            dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
                        }
                    }
                } else {
                    handleApiError(res);
                }
            }).catch((err: any) => {
                const config = Object.assign(err?.config, { serviceName: 'addAppleCare' });
                const error = { ...err, config }
                handleApiError(error);
            })
    }

    const captureDataApi = (scData: any) => {
        const sections: any = ({
            ...captureStructure,
            steps: captureStructure?.steps.map((step: any) => ({
                ...step,
                offerContainerId: scData.offerContainer[0].id,
                options: [
                    {
                        name: 'Login',
                        value: 'Mobily number',
                        fields: [
                            {
                                name: 'Mobily number',
                                value: msisdn
                            }
                        ]
                    }
                ],
                fields: step.fields.map((field: any) => {
                    let fieldValues = field;

                    if (field.name === 'Continue As Guest') {
                        fieldValues = ({
                            ...field,
                            value: 'No'
                        })
                    } else if (field.name === 'OTP') {
                        fieldValues = ({
                            ...field,
                            value: otpValue
                        })
                    } else if (field.name === 'CustomerRelatedAcccountInquiryResponse') {
                        fieldValues = ({
                            ...field,
                            value: JSON.stringify(customerInfo)
                        })
                    } else if (field.name === 'MobilyMSISDN') {
                        fieldValues = ({
                            ...field,
                            value: '' //pass encrpty BMNumber value when using ID Number in Login
                        })
                    } else if (field.name === 'NewStack') {
                        fieldValues = ({
                            ...field,
                            value: newStack
                        })
                    } else if (field.name === 'deviceInstallment') {
                        fieldValues = ({
                            ...field,
                            value: isInstallmentApplied ? 'true' : 'false'
                        })
                    }

                    return fieldValues
                })
            }))
        });

        captureData(scData, [sections])
            .then((res: any) => {
                if (res?.status === 200 && res?.data) {
                    dispatch({ type: "LOADER", payload: { loading: false } })
                    dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
                } else {
                    handleApiError(res);
                }
            }).catch(err => {
                handleApiError(err);
            })
    }


    return (
        <div className="container AppleCare__Container">
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Verify__Container'>
                <div className='SL__headerText'>
                    <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Verify_heading')}</Typography>
                    <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                        {t('Verify_Subheading')}
                        <div className='Verify__Msisdn'>{msisdn}.</div>
                        <div>{t('Verify_ToContinue')}</div>
                    </Typography>
                </div>

                <div className='Verify__OTP'>
                    <OTP isDisabled={isOTPDisabled} id="otp-input" rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                    {
                        timer > 0 ? (
                            <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                                {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                            </Typography>
                        ) : showOTPError ? (
                            <Typography className='Verify__otpError' rtl={rtl}>
                                {errorMessage}
                                {resendOption && <span id='resend-otp' className='Verify__sendAgain_error' onClick={handleResend}>
                                    {t("Send_again")}
                                </span>}

                            </Typography>
                        ) : (
                            <Typography className='Verify__Resend' rtl={rtl}>
                                {t("Didnt_receive_the_code")}
                                <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                                    {t("Send_again")}
                                </span>
                            </Typography>
                        )}
                </div>

                {notCustomer && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={t('Not_a_mobily_number')}
                        description={t('we_didnot_recognize_number')}
                        firstButtonText={t('got_it')}
                        modalFirstButtonClick={handleNotCustomer}
                    />
                )}
                {isGenericError && (
                    <ErrorModal
                        id={'otp_page_generic_error'}
                        rtl={rtl}
                        title={""}
                        description={t('Try_again', { source_code: t(errorCode) })}
                        firstButtonText={t('got_it')}
                        modalFirstButtonClick={handleGenericError}
                    />
                )}
            </div>
        </div>
    )
}

export default TermsOTP